const SCRIPT_ID = 'digital-checkout';
const SCRIPT_URL = `${process.env.PROVIDER_GETNET_URL}/digital-checkout/loader.js`;

export { SCRIPT_ID, SCRIPT_URL };
